import { Modal } from "react-bootstrap"
import doneIcon from '../../assets/images/done.png'
import './SuccessModal.css'

const SuccessModal = ({show, handleClose}) => {
    return (
        <Modal dialogClassName="success-modal" show={show} onHide={handleClose} centered>
            <Modal.Body>
                <div><img src={doneIcon} alt="doneIcon" width={128} /></div>
                <p className='font-32 '>Files Uploaded Successfully</p>
                <p className='font-16'>You can now start chatting with Brainyagent.</p>
                <button className='theme-sky-btn' onClick={handleClose}>Close</button>
            </Modal.Body>
        </Modal>
    )
}

export default SuccessModal
